function state() {
  return {
    tabData: {
      active: {
        pagination: {
          itemsPerPage: 10,
          itemsPerPageArray: [10, 20, 50, 100],
          page: 1,
        },
        totalItems: 0,
        searchBy: "customer_name",
        searchValue: "",
        status: { value: "ACTIVE" },
        policy_status: { value: "ALL" },
        showBy: { value: "created_at" },
        dateRange: null,
        type: { value: "ALL" },
        isSPKLinked: { value: "ALL" },
      },
      "cancellation-request": {
        pagination: {
          itemsPerPage: 10,
          itemsPerPageArray: [10, 20, 50, 100],
          page: 1,
        },
        totalItems: 0,
        searchBy: "customer_name",
        searchValue: "",
        status: { value: "CANCELLATION_REQUEST" },
        showBy: { value: "updated_at" },
        dateRange: null,
        type: { value: "ALL" },
        isSPKLinked: { value: "ALL" },
      },
      cancelled: {
        pagination: {
          itemsPerPage: 10,
          itemsPerPageArray: [10, 20, 50, 100],
          page: 1,
        },
        totalItems: 0,
        searchBy: "customer_name",
        searchValue: "",
        status: { value: "CANCELLED" },
        showBy: { value: "updated_at" },
        dateRange: null,
        type: { value: "ALL" },
        isSPKLinked: { value: "ALL" },
      },
      "accelerated-payment-request": {
        pagination: {
          itemsPerPage: 10,
          itemsPerPageArray: [10, 20, 50, 100],
          page: 1,
        },
        totalItems: 0,
        searchBy: "customer_name",
        searchValue: "",
        status: { value: "ACTIVE" },
        showBy: { value: "updated_at" },
        dateRange: null,
        type: { value: "ALL" },
        isSPKLinked: { value: "ALL" },
      },
      "accelerated-payment-approved": {
        pagination: {
          itemsPerPage: 10,
          itemsPerPageArray: [10, 20, 50, 100],
          page: 1,
        },
        totalItems: 0,
        searchBy: "customer_name",
        searchValue: "",
        status: { value: "SURRENDERED" },
        showBy: { value: "updated_at" },
        dateRange: null,
        type: { value: "ALL" },
        isSPKLinked: { value: "ALL" },
      },
      maturity: {
        pagination: {
          itemsPerPage: 10,
          itemsPerPageArray: [10, 20, 50, 100],
          page: 1,
        },
        totalItems: 0,
        searchBy: "customer_name",
        searchValue: "",
        status: { value: "MATURED" },
        policy_status: { value: "ALL", id: 0, label: "Semua" },
        showBy: { value: "updated_at" },
        dateRange: null,
        type: { value: "ALL" },
        isSPKLinked: { value: "ALL" },
      },
    },
  };
}

export default state;
